export const CHOROPLETH_COUNTRY_SOURCE = 'CHOROPLETH_COUNTRY_SOURCE';
export const CHOROPLETH_STATE_SOURCE = 'CHOROPLETH_STATE_SOURCE';

export const SELECTED_FEATURE_PROPERTY = 'SELECTED_FEATURE_PROPERTY';

export const SOURCE_LAYERS = {
	COUNTRIES: 'countries',
	STATES: 'admin1',
};
